"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEachEntry = forEachEntry;
exports.mapValues = mapValues;
exports.mean = mean;
exports.reduceObject = reduceObject;
exports.toIdMap = toIdMap;
exports.toIdMapFrom_id = toIdMapFrom_id;
exports.values = values;
/**
 * The array forEach function, implemented for object. The given callback will be called for each entry
 * @param  {Object}   object   The object
 * @param  {([Key, T]) => mixed} callback The callback function
 */
function forEachEntry(object, callback) {
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      callback([key, object[key]]);
    }
  }
}

/**
 * A function to map the values of object while preserving its keys.
 * @param  {Object}   object   The object
 * @param  {Function} callback The callback function
 */
function mapValues(object, callback) {
  const mappedObject = {};
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      mappedObject[key] = callback(object[key], key);
    }
  }
  return mappedObject;
}

/**
 * The array reduce function implemented for object
 * @param  {Object}   object   The object
 * @param  {Function} callback The callback function
 */
function reduceObject(object, callback, initialValue) {
  let previousValue = initialValue;
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      previousValue = callback(previousValue, object[key], key);
    }
  }
  return previousValue;
}

/**
 * Object.values function, but with the flow type maintained.
 */
function values(object) {
  const values = [];
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      values.push(object[key]);
    }
  }
  return values;
}

/**
 * mean - calculate the mean (average) of the data (null/undefined elements will not be considered a value to include)
 *
 * @param {(?number} data - the data to calculate means on
 *
 * @return {?number} - the mean of the data (null/undefined if there are not elements to mean)
 */
function mean(data) {
  let count = 0;
  let sum = 0;
  data.forEach(num => {
    if (typeof num !== 'number') {
      return;
    }
    sum += num;
    count += 1;
  });
  if (count === 0) {
    return null;
  }
  return sum / count;
}

/**
 * from an array of objects with _ids, create an object where keys are the _ids and
 * values are elements from  the array
 *
 * @param  {Array<T: { id: string }>} dataArray the elements to put into and id map
 *
 * @return {{id: T}} an id map
 */
function toIdMapFrom_id(dataArray) {
  const map = {};
  dataArray.forEach(data => {
    map[String(data._id)] = data;
  });
  return map;
}

/**
 * from an array of objects with ids, create an object where keys are the ids and
 * values are elments from  the array
 *
 * @param{Array<T: { id: string }>} dataArray the elements to put into and id map
 * @return {{id: T}} an id map
 */
function toIdMap(dataArray) {
  let map = {};
  dataArray.forEach(data => map[String(data.id)] = data);
  return map;
}